/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CategoryAdminDto } from '../models/CategoryAdminDto';
import type { CategoryClientDto } from '../models/CategoryClientDto';
import type { CategoryLevel } from '../models/CategoryLevel';
import type { GetAllCategoriesAdminResponse } from '../models/GetAllCategoriesAdminResponse';
import type { GetGetCategoriesClientResponse } from '../models/GetGetCategoriesClientResponse';
import type { Language } from '../models/Language';
import type { ListOf1OfCategoryClientDto } from '../models/ListOf1OfCategoryClientDto';
import type { ListOf1OfCategoryOperatorListedDto } from '../models/ListOf1OfCategoryOperatorListedDto';
import type { Pagination1OfCategoryAdminListedDto } from '../models/Pagination1OfCategoryAdminListedDto';
import type { PostCategoryRequestAdmin } from '../models/PostCategoryRequestAdmin';
import type { PutCategoryOrderRequestAdmin } from '../models/PutCategoryOrderRequestAdmin';
import type { PutCategoryRequestAdmin } from '../models/PutCategoryRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CategoriesService {
    /**
     * @returns ListOf1OfCategoryOperatorListedDto OK
     * @throws ApiError
     */
    public static getCategoriesOperator({
        branchId,
        level,
        parentId,
    }: {
        branchId: number,
        level?: CategoryLevel,
        parentId?: number,
    }): CancelablePromise<ListOf1OfCategoryOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/categories/{branchId}',
            path: {
                'branchId': branchId,
            },
            query: {
                'level': level,
                'parentId': parentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CategoryClientDto OK
     * @throws ApiError
     */
    public static getCategoryClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<CategoryClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/categories/{id}/public',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns GetGetCategoriesClientResponse OK
     * @throws ApiError
     */
    public static getCategoriesClient({
        branchId,
        level,
    }: {
        branchId: number,
        level?: CategoryLevel,
    }): CancelablePromise<GetGetCategoriesClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/categories',
            query: {
                'level': level,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ListOf1OfCategoryClientDto OK
     * @throws ApiError
     */
    public static getPublicCategoriesClient({
        level,
        language,
        branchId,
    }: {
        level?: CategoryLevel,
        language?: Language,
        branchId?: number,
    }): CancelablePromise<ListOf1OfCategoryClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/categories/public',
            query: {
                'level': level,
                'language': language,
                'branchId': branchId,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCategories`
     * @returns Pagination1OfCategoryAdminListedDto OK
     * @throws ApiError
     */
    public static getCategoriesAdmin({
        id,
        parentId,
        enabled,
        isSensitive,
        isServiceCategory,
        branchId,
        level,
        name,
        searchWord,
        categoryIds,
        page,
        limit,
    }: {
        id?: number,
        parentId?: number,
        enabled?: boolean,
        isSensitive?: boolean,
        isServiceCategory?: boolean,
        branchId?: number,
        level?: CategoryLevel,
        name?: string,
        searchWord?: string,
        categoryIds?: Array<number>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCategoryAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/categories',
            query: {
                'id': id,
                'parentId': parentId,
                'enabled': enabled,
                'isSensitive': isSensitive,
                'isServiceCategory': isServiceCategory,
                'branchId': branchId,
                'level': level,
                'name': name,
                'searchWord': searchWord,
                'categoryIds': categoryIds,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCategories`
     * @returns CategoryAdminDto OK
     * @throws ApiError
     */
    public static postCategoryAdmin({
        requestBody,
    }: {
        requestBody?: PostCategoryRequestAdmin,
    }): CancelablePromise<CategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/categories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCategories`
     * @returns GetAllCategoriesAdminResponse OK
     * @throws ApiError
     */
    public static getAllCategoriesAdmin({
        id,
        parentId,
        enabled,
        isSensitive,
        branchId,
        level,
        name,
        searchWord,
    }: {
        id?: number,
        parentId?: number,
        enabled?: boolean,
        isSensitive?: boolean,
        branchId?: number,
        level?: CategoryLevel,
        name?: string,
        searchWord?: string,
    }): CancelablePromise<GetAllCategoriesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/categories/all',
            query: {
                'id': id,
                'parentId': parentId,
                'enabled': enabled,
                'isSensitive': isSensitive,
                'branchId': branchId,
                'level': level,
                'name': name,
                'searchWord': searchWord,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCategoryDetails`
     * @returns CategoryAdminDto OK
     * @throws ApiError
     */
    public static getCategoryAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/categories/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCategories`
     * @returns CategoryAdminDto OK
     * @throws ApiError
     */
    public static putCategoryAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCategoryRequestAdmin,
    }): CancelablePromise<CategoryAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/categories/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCategoryAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/categories/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCategories`
     * @returns any OK
     * @throws ApiError
     */
    public static putCategoryOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCategoryOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/categories/{id}/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
